import React from 'react';
import { Link } from 'react-router-dom';

import { MCButton, TextField } from 'src/components/basic';
import BaseComponent from 'src/components/BaseComponent';

import { withRouter, scssVariables as variables, lang, permissions } from 'src/helpers';

import model from 'src/pages/auth/model';
import mainModel from 'src/model';

const apiStateId = 'password';

class RemoveAccountForm extends BaseComponent {
  componentDidMount() {
    model.subscribe(this.subscription);
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }

  handleSubmit = (event) => {
    event.preventDefault();
    mainModel.checkConfirmCookiePolicy().then((accept) => accept && model.loginPassword());
  };

  render() {
    const { handleChange, handleBlur } = model;
    const createState = model.getApiState(apiStateId);
    const { invalid } = createState;

    if (createState.error === 'EMAIL_TAKEN') {
      invalid['email'] = createState.errorMessage;
    }

    return (
      <div className={'mc-page-auth-box'}>
        <div className={'mc-box-header'}>
          <h4 className='mc-box-title'>{lang.t('Account removal request')}</h4>
          <div className='mc-box-title-note'>
            {lang.t('This will remove your account and all data assigned with that account')}
          </div>
        </div>
        {createState.error && <p className='mc-error'>{createState.errorMessage}</p>}
        <form className='mc-form' onSubmit={this.handleSubmit}>
          <TextField
            template={6}
            type='email'
            autoFocus={true}
            name={'username'}
            value={model.input('username')}
            onChange={(n, v) => {
              model.resetApiState(apiStateId);
              handleChange(n, v);
            }}
            onBlur={handleBlur}
            label={'Email address'}
            invalid={invalid}
          />
          <TextField
            template={6}
            type='password'
            name={'password'}
            label={'Password'}
            value={model.input('password')}
            onChange={(n, v) => {
              model.resetApiState(apiStateId);
              handleChange(n, v);
            }}
            onBlur={handleBlur}
            invalid={invalid}
          />

          <div className='mc-label-420' style={{ textAlign: 'right' }}>
            <Link
              to={permissions.PAGES.FORGOT_PASSWORD_PAGE.path}
              style={{ color: variables['colors-mc-primary'] }}
            >
              {lang.t('Forgot password?')}
            </Link>
          </div>
          <MCButton dark large primary radius disabled={createState.loading} type='submit'>
            {lang.t(createState.loading ? 'Please wait...' : 'Remove account and all data')}
          </MCButton>
        </form>
      </div>
    );
  }
}

export default withRouter(RemoveAccountForm);
